import React from "react";
import config from "./ModuleDefinition";
import EntityForm from "../../EntityForm/EntityForm";
import { entityToFormValuesMapper } from "../../../Common/utils";
import { withAuthorizationVerifier } from "../../../../../components/authorization-verifier";

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  return { ...formValues };
}

class FilterOptionForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit({ formValues }) {
    const { translations, ...rest } = formValues;
    this.props.onSubmitEntity({
      entity: { ...rest, filterOptionTranslations: translations },
    });
  }

  render() {
    const { name, validation, fields, renderers, translation, entities } = config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      nested,
      afterSubmit,
      onCancelEdit,
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        getListPath={getListPath}
        nested={nested}
        afterSubmit={afterSubmit}
        onCancelEdit={onCancelEdit}
        customEntityToFormValuesMapper={customEntityToFormValuesMapper}
      />
    );
  }
}

FilterOptionForm.propTypes = {};

FilterOptionForm.defaultProps = {};

export default withAuthorizationVerifier(FilterOptionForm);
